import SuccessfulActionModalBody from "#/shared/components/modals/SuccessfulActionModalBody"
import { ComponentStepProps } from "#/ui/Modal/StepperModal"

export default function SuccessfullyDepositedIntoVault({
  onClickContinue,
}: ComponentStepProps) {
  return (
    <SuccessfulActionModalBody
      title="Success"
      description="Congratulations!"
      onClickContinue={onClickContinue}
      nextStepButtonLabel="Done"
    />
  )
}
